module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orders-dialog"
  }, _vm._l((_vm.orders), function(orderId) {
    return _c('p', {
      key: orderId,
      staticClass: "dialog-order-item"
    }, [_c('a', {
      attrs: {
        "href": _vm.orderDetailUrlPrefix + orderId,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(orderId))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c9447c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmOrders/orders.vue
// module id = 1025
// module chunks = 0